/**
 * Extends the `Marionette.Layout` to supporting the concept of a view scope.
 *
 * @see Region
 * @see ViewScope
 */
define((require) => {
    "use strict";

    const {Layout} = require("marionette");

    const superInitializeRegions = Layout.prototype._initializeRegions;

    Layout.prototype._initializeRegions = function(options) {
        // Store a reference to the parent/owning view directly on the region. This is part
        // of making the concept of view scope work.
        this.listenTo(this, "region:add", (name, region) => {
            region.parentView = this;
        });

        superInitializeRegions.call(this, options);
    };
});



// WEBPACK FOOTER //
// ./src/shared/zbone/Layout.js